import React from "react";
import { List, ListItem, ListItemIcon, ListItemText, Box, Paper, useMediaQuery, useTheme, ListItemButton } from "@mui/material";
import { Build, DocumentScanner, Folder, Home, Person } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";

interface SidebarProps {
    mobileOpen: boolean;
    handleDrawerToggle: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ mobileOpen, handleDrawerToggle }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const navigate = useNavigate();
    const location = useLocation();

    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const userId = userData?.id;
    const userRole = userData?.role;

    // ✅ Sidebar Menu Data (Organized by Sections)
    const superadminMenuSections = [
        {
            title: "MANAGEMENT",
            items: [
                { text: "User", icon: <Person />, path: "/sa/users" },
                { text: "Space", icon: <Folder />, path: "/spaces" },
                { text: "Company", icon: <Build />, path: "/sa/companies" },
            ],
        }
    ];

    const adminMenuSections = [
        {
            title: "FOLDER",
            items: [{ text: "Space", icon: <Home />, path: "/spaces" }],
        },
    ];

    const companyadminMenuSections = [
        {
            title: "MANAGEMENT",
            items: [
                { text: "User", icon: <Person />, path: "/ca/users" },
            ],
        },
        {
            title: "Space",
            items: [{ text: "Space", icon: <Home />, path: "/ca/folderRepo" }],
        },

    ];

    return (
        <Paper
            sx={{
                position: "fixed",
                left: mobileOpen ? "10px" : (isMobile ? "-100vw" : "-260px"),
                top: "80px",
                width: isMobile ? "95vw" : "250px",
                height: "calc(100vh - 90px)",
                overflowY: "auto",
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                padding: mobileOpen ? "15px" : "0px",
                zIndex: 1300,
                transition: "left 0.3s ease-in-out",
            }}
        >
            {/** Dynamically Set Menu Sections **/}
            {userRole === "superadmin" && superadminMenuSections.map((section) => (
                <Box key={section.title}>
                    {/* Section Title */}
                    <Box sx={{ fontWeight: "bold", fontSize: "14px", color: "gray", padding: "10px 15px" }}>
                        {section.title}
                    </Box>

                    {/* Section Items */}
                    <List>
                        {section.items.map((item) => (
                            <ListItem key={item.text} disablePadding>
                                <ListItemButton
                                    selected={location.pathname === item.path}
                                    sx={{
                                        "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#2ecc71" },
                                    }}
                                    onClick={() => {
                                        navigate(item.path);
                                        if (isMobile) handleDrawerToggle();
                                    }}
                                >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.text} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            ))}

            {userRole === "admin" && adminMenuSections.map((section) => (
                <Box key={section.title}>
                    {/* Section Title */}
                    <Box sx={{ fontWeight: "bold", fontSize: "14px", color: "gray", padding: "10px 15px" }}>
                        {section.title}
                    </Box>

                    {/* Section Items */}
                    <List>
                        {section.items.map((item) => (
                            <ListItem key={item.text} disablePadding>
                                <ListItemButton
                                    selected={location.pathname === item.path}
                                    sx={{
                                        "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#2ecc71" },
                                    }}
                                    onClick={() => {
                                        navigate(item.path);
                                        if (isMobile) handleDrawerToggle();
                                    }}
                                >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.text} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            ))}

            {(userRole === "user" && userData.is_company_admin == '1') && companyadminMenuSections.map((section) => (
                <Box key={section.title}>
                    {/* Section Title */}
                    <Box sx={{ fontWeight: "bold", fontSize: "14px", color: "gray", padding: "10px 15px" }}>
                        {section.title}
                    </Box>

                    {/* Section Items */}
                    <List>
                        {section.items.map((item) => (
                            <ListItem key={item.text} disablePadding>
                                <ListItemButton
                                    selected={location.pathname === item.path}
                                    sx={{
                                        "&.Mui-selected": { backgroundColor: "#E0F7FA", color: "#2ecc71" },
                                    }}
                                    onClick={() => {
                                        navigate(item.path);
                                        if (isMobile) handleDrawerToggle();
                                    }}
                                >
                                    <ListItemIcon>{item.icon}</ListItemIcon>
                                    <ListItemText primary={item.text} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Box>
            ))}
        </Paper>
    );

};

export default Sidebar;
